const PromptSearch = ({ onSearch, searchQuery }) => {
  const handleInputChange = (e) => {
    onSearch(e.target.value);
  };
  return (<input
    type="text"
    placeholder="Search prompt"
    onChange={handleInputChange}
    value={searchQuery}
  />);
};

export default PromptSearch;